import {
  Col,
  InputNumber,
  Modal,
  Row,
  Space,
  Typography,
  message,
  Select,
} from "antd";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { GlobalContext } from "../../App";
import { WARNING_NOTIFICATION_TYPE, ERROR_NOTIFICATION_TYPE,
  getAPIResponseMessage, } from "../../utils/api/_ConstantsAPI";
import ORPrint from "../../components/PDFDocuments/ORPrint";
import CustomModal from "../../components/Modals/CustomModal";
import { getBankList } from "../../utils/api/BankApi";
import BankDefaultType from "../../utils/types/BankDefaultType";


export default function PaymentModal({
  isOpen,
  setIsOpen,
  amountToPay,
  handleOnSuccessPayment,
  dataSource,
}) {
  const { openNotification } = useContext(GlobalContext);

  const [isLoading, setIsLoading] = useState(false);
  const [tenderedAmount, setTenderedAmount] = useState(0);

  const [modalWidth, setModalWidth] = useState("30vw");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);


  const [selectedMOP, setSelectedMOP] = useState({});
  const [bankDataList, setBankDataList] = useState([]);
  const [selectedBank, setselectedBank] = useState(null);

  console.log(selectedBank);

  useEffect(() => {
    const updateModalWidth = () => {
      setModalWidth(window.innerWidth < 768 ? "90%" : "30vw");
    };
    updateModalWidth(); // Set initial width
    window.addEventListener("resize", updateModalWidth);

    return () => window.removeEventListener("resize", updateModalWidth);
  }, []);



  const fetchBanks = async () => {
    setIsLoading(true);
    const res = await getBankList();
    console.log(res);
    if (res.isSuccess) {
      const banks = res.bank_list;
      setBankDataList(banks);
    } else {
      openNotification(
        ERROR_NOTIFICATION_TYPE,
        "Bank List",
        getAPIResponseMessage(res.data)
      );
    }
    setIsLoading(false);
  };


  useEffect(() => {
    if (selectedMOP === 1 && bankDataList.length > 0) {
      setselectedBank(bankDataList[0].bank_id);
    }
  }, [selectedMOP, bankDataList]);



  return (
    <>
      <Modal
        centered
        closable={false}
        maskClosable={false}
        open={isOpen}
        keyboard={false}
        onOk={() => {
          if (tenderedAmount >= amountToPay) {
            setIsLoading(true);
            setIsSuccessModalOpen(true);

            handleOnSuccessPayment(tenderedAmount,selectedMOP,selectedBank);
            setIsOpen(false);
          } else {
            openNotification(
              WARNING_NOTIFICATION_TYPE,
              "Payment",
              "Insufficient amount!"
            );
          }
        }}
        confirmLoading={isLoading}
        onCancel={() => setIsOpen(false)}
        okText="Pay"
      >
        <Row justify="left" align="left" className="mb-3">
          <Col span={24}>
            <Typography.Title level={2}>
              Please pay amount of: &#8369;{amountToPay}
            </Typography.Title>
          </Col>
          <Col span={24}>
            <InputNumber
              min={0}
              // max={parseInt(originalPricePerKg)}
              type="number"
              controls={false}
              value={tenderedAmount}
              style={{
                width: "100%",
                fontSize: "30px",
              }}
              onChange={(value) => {
                setTenderedAmount(value);
              }}
              className="mt-2 py-1"
            />
          </Col>
        </Row>

        <Row justify="left" align="left" className="mb-3">
          <Col span={24}>
            <Select
              style={{ width: "100%" }}
              size="large"
              loading={isLoading}
              disabled={isLoading}
              showSearch={false} // optional, since 2 options lang
              placeholder="Select Payment Method"
              defaultValue={0}
              onChange={(value) => {
                setSelectedMOP(value);
              
                if (value === 1) {
                  // Call API for bank list if Online is selected
                  fetchBanks();
                }
              
              }}
            >
              <Select.Option value={0}>Cash</Select.Option>
              <Select.Option value={1}>Online</Select.Option>
            </Select>
          </Col>
        </Row>




        {selectedMOP === 1 && bankDataList.length !== 0 && (
          <Row justify="center" align="middle" className="mb-4">
           
            <Col span={24}>
              <Select
                style={{ width: "100%" }}
                size="large"
                loading={isLoading}
                disabled={isLoading}
                showSearch
                placeholder="Select Bank"
                value={selectedBank ?? bankDataList[0].bank_id}
                onChange={(value) => {
                  const bank = bankDataList.find((bankDataList) => bankDataList.bank_id === value);
                  setselectedBank(bank.bank_id);
                }}
                filterOption={(inputValue, option) => {
                  const optionDescription = option.children.toLowerCase();
                  return (
                    optionDescription.indexOf(inputValue.toLowerCase()) >= 0
                  );
                }}
              >
                {bankDataList.map((record, index) => (
                  <Select.Option key={index} value={record.bank_id}>
                    {record.bank_desc}
                  </Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
        )}



      </Modal>

      <CustomModal
        isLoading={isLoading}
        isOpen={isSuccessModalOpen}
        setIsOpen={setIsSuccessModalOpen}
        cancelText="Close"
        props={{
          okButtonProps: { hidden: true },
          width: modalWidth, // Dynamically set width
        }}
        isClosable={true}
      >
        <ORPrint ORDetails={dataSource} />
        {/* {dataSource.length > 0 && <ORPrint ORDetails={dataSource} />} */}
      </CustomModal>
    </>
  );
}
